import { useContext, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import AuthContext from "../context/auth/AuthContext";

const ProtectedRoute = () => {
  const { configError, configStatus, logoutUser, token } =
    useContext(AuthContext);

  const isInvalidToken = () => {
    if (!token) {
      return false;
    }

    try {
      const { exp } = jwtDecode(token);
      const currentTimestamp = Date.now() / 1000;
      return exp < currentTimestamp;
    } catch (e) {
      return true;
    }
  };

  const invalidToken = isInvalidToken();

  useEffect(() => {
    if (token && invalidToken) {
      logoutUser();
    }
  }, [invalidToken, logoutUser, token]);

  if (!token || invalidToken) {
    return <Navigate to="/login" replace />;
  }

  if (configStatus !== "ready") {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-neutral-light text-textBase">
        {configStatus === "error"
          ? (configError ?? "Unable to load tenant config.")
          : "Loading..."}
      </div>
    );
  }

  return <Outlet />;
};

export default ProtectedRoute;
